import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MethodSection } from './components/MethodSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-stone-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <div className="w-full h-px bg-amber-200/50" data-id="element-3"></div>
      <ProblemSection data-id="element-4" />
      <FailedApproaches data-id="element-5" />
      <MethodSection data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <AudienceSection data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <ProofSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <OfferSection data-id="element-12" />
      <FooterSection data-id="element-13" />
    </div>;
}